// extracted by mini-css-extract-plugin
export var accordion = "ArticleAccordion-module--accordion---uiwC";